import React, { FC } from 'react';
import MuiSwitch from '@mui/material/Switch';

export interface SimpleSwitchPropsType {
    value?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    'data-testid'?: string;
}

const SimpleSwitch: FC<SimpleSwitchPropsType> = (props) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (props.onChange) {
            props.onChange(checked);
        }
    };

    return (
        <MuiSwitch
            checked={!!props.value}
            onChange={handleChange}
            disabled={props.disabled}
            inputProps={{ 'data-testid': props['data-testid'] } as React.InputHTMLAttributes<HTMLInputElement>}
        />
    );
};

export default SimpleSwitch;
